import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getOrganizationProfileFormBuilderHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.organizationProfileFromList(action.payload),
		);
		yield put({
			type: types.GET_ORGANIZATIONPROFILEFORMLIST_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_ORGANIZATIONPROFILEFORMLIST_ERROR,
			payload,
		});
	}
}

export function* getOrganizationProfileFormBuilderWatcherSaga() {
	yield takeLatest(
		types.GET_ORGANIZATIONPROFILEFORMLIST_START,
		getOrganizationProfileFormBuilderHandlerSaga,
	);
}

//get/id

//create
